import React, { ReactElement, useEffect, useState } from 'react';
import { useUserContext } from '../../_context/UserContext'
import { Navigate } from 'react-router-dom';
import { Spinner, Container, Row, Col } from 'react-bootstrap';

interface PrivateRouteProps {
  children: ReactElement | ReactElement[];
}

const PrivateRoute: React.FC<PrivateRouteProps> = ({children}) => {
  const { isLogged, jwtToken } = useUserContext();
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    // Add a small delay to ensure authentication state is properly loaded
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 100);

    return () => clearTimeout(timer);
  }, []);

  // Show loading spinner while checking authentication
  if (isLoading) {
    return (
      <Container className="d-flex justify-content-center align-items-center" style={{ minHeight: '100vh' }}>
        <Row>
          <Col className="text-center">
            <Spinner animation="border" role="status">
              <span className="visually-hidden">Loading...</span>
            </Spinner>
            <p className="mt-2">Checking authentication...</p>
          </Col>
        </Row>
      </Container>
    );
  }

  // Check if user is logged in and has a valid token
  const isAuthenticated = isLogged && jwtToken && jwtToken !== "no Token Found";
  
  return isAuthenticated ? <>{children}</> : <Navigate to="/" replace />;
}

export default PrivateRoute;
